export default __webpack_public_path__ + "static/reading loop-25905a7729ff11c98a25eae467a685e1.png";